import React from 'react';
import AutomotiveIntro from '../components/AutomotiveIntro/AutomotiveIntro';
import CtaSection from '../components/CtaSection/CtaSection'; // Import CTA

const AutomotivePage = () => {
  return (
    <>
      <AutomotiveIntro />
      <CtaSection />
    </>
  );
};

export default AutomotivePage;
